import { render, staticRenderFns } from "@/shared/components/Pagination/Pagination.pug?vue&type=template&id=66b11a18&scoped=true&lang=pug&external"
import script from "./Pagination.component.vue?vue&type=script&lang=ts"
export * from "./Pagination.component.vue?vue&type=script&lang=ts"
import style0 from "@/shared/components/Pagination/Pagination.scss?vue&type=style&index=0&id=66b11a18&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b11a18",
  null
  
)

export default component.exports